import { useQuery } from "@tanstack/react-query";
import { getActivityLocationsUrl } from "../helpers/getActivityLocationsUrl";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";

export const useActivityLocations = (
  taskType: string = "all",
  addonLocationType: string,
  enabled = true
) => {
  return useQuery<string[]>({
    queryKey: ["locations", taskType, addonLocationType],
    queryFn: async () => {
      const url = `${TASKS_SERVICE_URL}/v1/${getActivityLocationsUrl(taskType, addonLocationType)}`;
      const { result } = await fetchAPI("GET", url);
      return result.data;
    },
    staleTime: INTERVAL.MINUTE,
    enabled,
  });
};
